import { render, staticRenderFns } from "./PermissionsTab.vue?vue&type=template&id=74a96db7&"
import script from "./PermissionsTab.vue?vue&type=script&lang=js&"
export * from "./PermissionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports